
import theme from "./Theme";

const globalStyle = {
    walletContainer: {
        margin: "10px",
        padding: { xs: "4px", lg: "8px" },
        borderRadius: "8px",
        bgcolor: "#f5f5f5",
        position: "relative",
        transition: "all 0.3s ease",
        "&:hover": {
            cursor: "pointer",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
        },
    },
    walletAddressText: {
        fontSize: "0.8rem",
        fontWeight: "600",
        color: "#000",
        marginLeft: "5px",
    },
    smallText: {
        fontSize: "0.8rem",
        fontWeight: "600",
        color: "#000",
    },
    buttonWrapper: {
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "12px",

        "&:hover": {
            cursor: "pointer",
        },
        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        padding: { xs: "0.3em 0.3em", lg: "0.3em 1em" },
        color: "white",
        fontSize: "0.8rem",
        fontWeight: "600",
        textTransform: "uppercase",
    },

};

export default globalStyle;
